<template>
  <div class="container-fluid component">
    <p class="h4 heading branding">Welcome, GE user! <help :portal="portal" class="pull-right padding-80" /></p>

    <p>
      Please fill out the required information below to register as a new user of the CFM web portal.<br />
      Your request will be routed to a CFM Sponsor for approval.
    </p>

    <form @submit.prevent>
      <div class="form-group">
        <label for="sso" class="control-label required">SSO</label>
        <input
          id="sso"
          v-model.trim="user.sso"
          v-focus
          class="sso form-control"
          type="text"
          placeholder="Please enter your SSO"
        />
        <div v-if="$v.user.sso.$invalid && $v.user.sso.$dirty" class="text-danger input-error">
          Enter a valid sso number
        </div>
      </div>

      <div class="form-group">
        <label for="" class="control-label required">Do you need the ability to Purchase Parts?</label>
        <div class="radio-btns">          
            <div class="radio-btn">
              <input
                id="materialBuyerAccessYes"
                v-model="user.materialBuyerAccess"
                type="radio"
                value="Yes"
              />
              <label for="materialBuyerAccessYes">Yes</label>
            </div>
            <div class="radio-btn">
              <input id="materialBuyerAccessNo" v-model="user.materialBuyerAccess" type="radio" value="No"/>
              <label for="materialBuyerAccessNo">No</label>
            </div>
        </div>
        <div v-if="!$v.user.materialBuyerAccess.required && $v.user.materialBuyerAccess.$error" class="text-danger">
          Please select do you need the ability to Purchase Parts
        </div>
      </div>

      <div class="form-group">
        <label foe="comments">Comments</label>
        <textarea
          id="comments"
          v-model="user.comments"
          maxlength="200"
          rows="3"
          class="form-control comments"
          placeholder="You can leave your comments here"
        />
      </div>

      <div id="recaptcha">
        <BotControlAOB
          :display-data="showRecaptcha"
          @closeModal="showRecaptcha = false"
          @recaptchaResponseData="onRequestAccess"
        />
      </div>
      <div class="action-btns">
        <input type="submit" class="btn btn-sm btn-primary" value="Request Access" @click="displayCaptcha" />
        <input type="button" class="btn btn-sm btn-default" value="Back" @click="goBack" />
      </div>
    </form>

    <spinner
      ref="spinner"
      v-model="showSpinner"
      fixed
      size="lg"
      text="Please be patient we are processing your request. Please do not hit the back button/resubmit or a duplicate request may be created."
    />

    <!-- notification failure -->
    <modal v-model="registrationFailed" effect="fade" width="40%">
      <div slot="modal-header" class="modal-header"><strong class="modal-title">Message</strong></div>
      <div>
        <span class="fa fa-exclamation text-warning fa-lg" />
        Your request could not be submitted due to an intermittent connection issue! Please try submitting your request
        again after sometime.
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button id="forgotUser" type="button" class="btn btn-sm btn-primary" @click="regFailed()">
          OK
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
import { maxLength, minLength, numeric, required } from "vuelidate/lib/validators";
import { addNewGeUser } from "@/services/endpointsService";
import spinner from "build-ui-x/src/Spinner";
import help from "./HelpInfo";
import { mapState } from "vuex";
import BotControlAOB from "@/mycfm/components/new-company/BotControlAOB";
import modal from "build-ui-x/src/Modal";

export default {
  components: {
    spinner,
    help,
    BotControlAOB,
    modal
  },
  props: {
    portal: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showSpinner: false,
      showRecaptcha: false,
      registrationFailed: false
    };
  },
  validations: {
    user: {
      sso: {
        required,
        numeric,
        minLength: minLength(9),
        maxLength: maxLength(9)
      },
      comments: {
        maxLength: maxLength(200)
      },
      materialBuyerAccess: {
        required
      }
    }
  },
  computed: {
    ...mapState("user", ["user"])
  },
  methods: {
    regFailed() {
      this.registrationFailed = false;
      window.location.reload();
    },
    displayCaptcha() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      this.showRecaptcha = true;
      if (window.grecaptcha) {
        window.grecaptcha.reset();
      }
    },
    onRequestAccess(recaptchaValue) {
      let data = {
        email: this.user.email,
        sso: this.user.sso,
        comments: this.user.comments,
        materialBuyerAccess: this.user.materialBuyerAccess
      };
      let config = {
        headers: {
          "g-recaptcha-response": recaptchaValue
        }
      };
      this.showSpinner = true;
      //add user
      addNewGeUser(data, config)
        .then(data => {
          if (data) {
            this.$store.dispatch("user/setActivePage", "thankyouPage");
          }
        })
        .catch(() => {
          this.registrationFailed = true;
        })
        .finally(() => {
          // hide spinner
          this.showSpinner = false;
        });
    },
    goBack() {
      this.$store.dispatch("user/resetGeForm");
      this.$store.dispatch("user/setActivePage", "welcomePage");
    }
  }
};
</script>

<style lang="less" scoped>
.component h3 {
  margin-top: 0;
}
.sso,
.comments {
  width: 300px;
}

.branding {
  font-size: 23px;
  font-weight: bold;
  color: #004bbd;
  font-family: apexSans;
}
</style>
